import {RiDeleteBin5Fill} from "react-icons/ri";
import {BiEditAlt} from "react-icons/bi";

export const renderColumns = (handleEdit, handleReject) => {
    return [
        {
            dataIndex: "branch_name",
            key: "branch_name",
            title: "Nama Cabang",
        },
        {
            dataIndex: "account_number",
            key: "account_number",
            title: "No. Rekening",
        },
        {
            dataIndex: "card_number",
            key: "card_number",
            title: "No. Kartu",
        },
        {
            dataIndex: "account_name",
            key: "account_name",
            title: "Nama Rekening",
        },
        {
            dataIndex: "bank_name",
            key: "bank_name",
            title: "Nama Bank",
        },
        {
            dataIndex: "account_book",
            key: "account_book",
            title: "Buku Rekening",
        },
        {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            render: (_, record) => (
                <div className="text-center">
                    <div className="">
                        <button className="btn btn-sm bgc-41526E text-white" style={{width: 80}} onClick={() => handleEdit(record)}>Ubah</button>
                    </div>
                    <div className="mt-1">
                        <button className="btn btn-sm btn-danger" style={{width: 80}} onClick={() => handleReject(record)}>Hapus</button>
                    </div>
                </div>
            ),
        },
    ];
};
